import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useApiMutation } from './useApiMutation';

const useUpdateUser = ({ useruuid, ...options } = {}) => {
  const trans = useSelector(translator);
  const userApi = useSelector((state) => state.apis.userApi);

  return useApiMutation(
    (user) =>
      new Promise((resolve, reject) => {
        userApi.updateUser(
          user,
          apiCallback({
            translator: trans,
            successCallback: resolve,
            failCallback: reject,
            errorCallback: reject,
          })
        );
      })
  );
};

export default useUpdateUser;
